import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal, Row, Spin, Upload } from 'antd';
import QRCode from 'react-qr-code';
import * as signalR from '@microsoft/signalr';
import { configManager } from 'react-structure-admin';

import useAuth from 'core/hooks/useAuth';
import ResCol from './ResCol';

const SharingFileQRCode = ({ onClose, supportedTypes = [], onNewUpload }) => {
  const [token, setToken] = useState(null);
  const [files, setFiles] = useState([]);
  const [fileUploadedd, setFileUploadedd] = useState(null);
  const { user, systemSettings } = useAuth();

  const { apiUrl } = configManager.getConfig();

  const normalizeFile = (file) => {
    return {
      uid: file.id,
      name: file.name,
      status: 'done',
      url: `${process.env.REACT_APP_API_URL}/archives/${file.id}/binary`,
      thumbUrl: `${process.env.REACT_APP_API_URL}/archives/${file.id}/binary`,
      extension: file.extension
    };
  };

  const handleUploadFile = (file) => {
    setFiles((prevStates) => [...prevStates, normalizeFile(file)]);
    setFileUploadedd(file);
  };

  useEffect(() => {
    const socket = new signalR.HubConnectionBuilder()
      .withUrl(`${apiUrl}/hubs/file-share`, {})
      .configureLogging(signalR.LogLevel.None)
      .withAutomaticReconnect()
      .build();

    socket
      .start()
      .then(() => {
        socket
          .invoke('GetToken', user.id, supportedTypes)
          .then((token) => {
            setToken(token);
          })
          .catch(console.log);
      })
      .catch((error) => console.log(error));

    socket?.on('OnUpload', (file) => {
      handleUploadFile(file);
    });

    return () => {
      socket.off('OnUpload');
      socket.stop();
    };
  }, []);

  useEffect(() => {
    if (fileUploadedd) {
      onNewUpload({ ...fileUploadedd });
      setFileUploadedd(null);
    }
  }, [fileUploadedd]);

  const url = `${systemSettings.appUrl}/upload?token=${token}`;

  return (
    <Modal
      visible
      footer={<Button onClick={onClose}>Voltar</Button>}
      width={900}
      onCancel={onClose}
    >
      <div className="gx-sharingfileqrcode-container gx-text-center gx-d-flex gx-h-100 gx-align-items-center gx-justify-content-center">
        <Row
          className="gx-sharingfileqrcode-success gx-h-100 gx-w-100"
          align="middle"
          justify="space-between"
        >
          <ResCol span={12}>
            <div className="gx-flex-row gx-align-items-center gx-justify-content-center">
              {token ? (
                <QRCode value={url} />
              ) : (
                <Spin className="gx-p-0 gx-m-0" />
              )}
            </div>
          </ResCol>

          <ResCol span={12}>
            <div className="gx-flex-column gx-align-items-center">
              <Alert
                showIcon
                type="info"
                description={
                  <span>
                    Leia o <strong>QR Code</strong> para receber anexos de
                    outros dispositivos.
                  </span>
                }
                className="gx-mt-2 gx-border-0"
                message={<h2>Compartilhar anexos</h2>}
              />

              <Upload
                className="gx-mt-2"
                fileList={files}
                showUploadList={{
                  showDownloadIcon: true,
                  showRemoveIcon: false
                }}
              />
            </div>
          </ResCol>
        </Row>
      </div>
    </Modal>
  );
};

export default SharingFileQRCode;
